import React from 'react';
import { Icon } from 'react-native-elements';
import Colors from '../constants/Colorsv2';
import { Text, TouchableOpacity } from '../globalComponents/NativeOverrides';
import { isIOS, isSafari, isAndroid, isChrome, deviceDetect, isMobile } from 'react-device-detect';
import { BEEventApi } from 'be-components';
import { useDispatch } from 'react-redux';
import { player_getHelpPromptById } from '../store/actionsv1/player';

const isAndroidPWAInstalled = () => {
    return (window.matchMedia('(display-mode: standalone)').matches);
}

const isIOSPWAInstalled = () => {
    if(('standalone' in window.navigator) && (window.navigator.standalone)){ return true }
    return false
}

const isPWAInstalled = () => {
    
    if(isSafari && isIOS){ return isIOSPWAInstalled() }
    if(isAndroid){ return isAndroidPWAInstalled() }
    return false
}

const PWAPrompt = ({}) => {
    //const device = { ...deviceDetect(undefined), pwa:isPWAInstalled(), mobile_type: isAndroid?'android':isIOS?'ios':undefined }
    const dispatch = useDispatch();
    const handlePWAPress = () => {
        //if(isIOS && !isSafari){ alert('Please open app.bettoredge.com in safari to install') }
        //if(!document){ return }
        //const element = document.getElementById('install-dialog')
        //if(element){ element.show() }
        dispatch(player_getHelpPromptById('t2_beta'))
        BEEventApi.saveEvent({
            event_name: 'viewed_pwa_prompt',
            event_data: {

            },
            level:1
        })
    }
    //If the PWA is already installed, we need to render nothing
    if(isPWAInstalled()){ return <></> }
    //if(!device.isMobile){ return <></> }
    return (
        <TouchableOpacity 
            style={{ flexDirection:'row', alignItems:'center', borderRadius:20, backgroundColor:Colors.highlights.highlight400Faded, padding:5, paddingTop:10, paddingBottom:10 }} 
            //native_id={deferred_prompt?'t2_android_install':'t2_ios_install'}
            onPress={() => handlePWAPress()}>
            <Icon name='smartphone' type='feather' color={Colors.shades.white} size={14}/>
            <Text style={{ marginLeft:3 }} size={12} color={Colors.shades.white} weight='semibold'>Get The App</Text>
        </TouchableOpacity>
    )

}

export default PWAPrompt